import Skeleton from '@mui/material/Skeleton';

import {
  StyledCard,
  StyledCardContent,
  StyledCardHeader,
} from './OrderProviderExternalErrorsPeriodChart.styled';

export const OrderProviderExternalErrorsPeriodChartSkeleton: React.FC = () => (
  <StyledCard>
    <StyledCardHeader title={<Skeleton variant="text" width={400} />} titleSize="small" />
    <StyledCardContent>
      <Skeleton height="100%" variant="rectangular" width="100%" />
    </StyledCardContent>
  </StyledCard>
);
